module.exports = __webpack_public_path__ + "img/cultural-event-placeholder.1c690280.jpg";